import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import NavBar from './components/navBar/NavBar';
import Information from './pages/Information';
import Contact from './pages/Contact';
import Rules from './pages/Rules';
import { Container, Dialog } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import './App.css';
import 'leaflet/dist/leaflet.css';
import LosHeroes from './components/losHeroes/LosHeroes';
import Checkout from './components/checkout/Checkout';
import MainConcept from './components/MainConcept';
import ReservationSummary from './components/checkout/ReservationSummary';
import Cookies from 'js-cookie';


const serverRoute = "/MotorReservasAdmintour"

const theme = createTheme({
  palette: {
    background: {
      default: '#F9F9F9',
    },
    primary: {
      light: '#008EAA',
      main: '#007289',
      dark: '#015869',
      contrastText: '#fff',
    },
    secondary: {
      light: '#008EAA',
      main: '#007289',
      dark: '#015869',
      contrastText: '#fff',
    },
  },
});

function App() {
  /*const [popupOpen, setPopupOpen] = useState(true);

  const closePopup = () => {
    setPopupOpen(false);
  };
*/
  const navList = [
    {
      title: "Disponibilidad",
      path: "/MotorReservasAdmintour/disponibilidad",
    },
    {
      title: "Información",
      path: "/MotorReservasAdmintour/informacion",
    },
    {
      title: "Contacto",
      path: "/MotorReservasAdmintour/contacto",
    },
    {
      title: "Normas",
      path: "/MotorReservasAdmintour/normas",
    },
  ];

  const location = useLocation();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const hotCode = params.get('hotCod');

    if (hotCode) {
      const existingHotCode = Cookies.get('hotCod');

      //if (!existingHotCode || existingHotCode !== hotCode) {
      console.log("existingcode", existingHotCode);  
      Cookies.set('hotCod', hotCode, { expires: 1 });
      console.log("segunod", Cookies.get('hotCod'));
      //}
    }

    setLoading(false); // Desactiva el indicador de carga una vez que se completa la acción
  }, [location.search]);

  if (loading) {
    return <div>Loading...</div>; // Muestra un indicador de carga mientras se realiza la acción
  }


  return (
    <ThemeProvider theme={theme}>
      <NavBar navList={navList} />
      <Container sx={{ mt: 0 }}>
        <Routes>
          <Route path={serverRoute} element={<Navigate to="/MotorReservasAdmintour/disponibilidad" replace />} />
          <Route path="/MotorReservasAdmintour/disponibilidad/*" element={<MainConcept />} />
          <Route path="/MotorReservasAdmintour/informacion" element={<Information />} />
          <Route path="/MotorReservasAdmintour/contacto" element={<Contact />} />
          <Route path="/MotorReservasAdmintour/normas" element={<Rules />} />
          <Route path="/MotorReservasAdmintour/checkout" element={<Checkout />} />
          <Route path="/MotorReservasAdmintour/resumenReserva" element={<ReservationSummary />} />
        </Routes>
      </Container>
    </ThemeProvider>
  );
}

export default App;